import { KYMW1318Model } from '../kymw1318.model';
import { DeletePlanGoodsInfoModel } from '../vo/kymw1318-delete-plan-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 選定解除企画商品情報削除サービス
 *
 * @export DeletePlanGoodsInfoService
 * @class DeletePlanGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeletePlanGoodsInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1318Model}
   * @memberof DeletePlanGoodsInfoService
   */
  private model: KYMW1318Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {DeletePlanGoodsInfoModel}
   * @memberof DeletePlanGoodsInfoService
   */
  private vo: DeletePlanGoodsInfoModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof DeletePlanGoodsInfoService
   */
  private successFunc: Function;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeletePlanGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      delete: {
        DeletePlanGoodsInfo: {
          condition: {
            PCode: this.vo.pCode
          },
          combination: this.vo.planGoodsList.map((_) => {
            return {
              condition: {
                OrderCode: _.orderCode,
                MediumType: _.mediumType
              }
            }
          })
        }
      },
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof DeletePlanGoodsInfoService
   */
  execute(model: KYMW1318Model, vo: DeletePlanGoodsInfoModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deletePlanGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeletePlanGoodsInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
